/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { DETAIL_DATA } from "./test-data/product.detail";

import {GET_ASSET_DETAIL} from "../pages/Collectibles/graphql/getasset-detail.query";


const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export class AssetDetailService {
    private static instance: AssetDetailService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): AssetDetailService {
        if (!AssetDetailService.instance) {
            AssetDetailService.instance = new AssetDetailService(props);
        }
        return AssetDetailService.instance;
    }

    async getAssetDetail(assetId: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId:assetId,
                        storeId:"61739cbd2fbe0a187c984fb6"
                    },
                });
                if(res){
                    let _data = res?.data?.getAsset
                    let _found ={
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        serialNo: _data?.serialNo,
                        tag: 'GOLD',
                        category: 'gold',
                        price: _data?.price?.map((item:any)=>{
                            return({
                                ...item,
                                locale: 'en-US',
                                amount:parseInt(item?.amount?.slice(1, item?.amount?.length))
                            })
                        }),
                        meta: _data?.attrs?.map((item:any)=>{
                            return({
                                key:item?.name,
                                value: item?.val,
                                disp_type:item?.disp_type
                            })
                        }),
                        buttons: [
                            {
                                key: "buyNowFiat",
                                title: "Buy in USD"
                            },
                            {
                                key: "buyNowCrypto",
                                title: "Buy in ETH"
                            }
                        ],
                        images: _data?.media?.map((item:any)=>{
                            return({
                                original:item?.src,
                                thumbnail:item?.thumbnail,
                                thumbnailHeight: "70",
                                thumbnailClass:"image-thumb"
                            })
                        }),
                        timeline: _data?.timeline?.map((item:any)=>{
                            return({
                                title: `Asset ${item?.event}ed`,
                                description:[
                                    // {
                                    //     displayType: "date",
                                    //     key: "Listed At",
                                    //     value: item?.date?.toISOString()
                                    // },
                                    {
                                        displayType: "link",
                                        key: "From",
                                        value: item?.from?.value,
                                        link: item?.from?.link
                                    },
                                    {
                                        displayType: "link",
                                        key: "To",
                                        value: item?.to?.value,
                                        link: item?.to?.link
                                    },
                                    {
                                        displayType: "link",
                                        key: "Proof of List",
                                        value: item?.proof?.value,
                                        link: item?.proof?.link
                                    }
                                ]
                            })
                        }),
                    }
                if(_found){
                    return _found;
                }                
                }
            }
        } catch (err) {
            return err;
        }
    }
}
